// extracted by mini-css-extract-plugin
export default {"element":"FormElement-modules__element__u2sDB"};